import React from 'react';
export function PaintSplashes() {
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-131">
      {/* === INK SPLASHES — organic blob shapes at 10-15% opacity === */}

      {/* Cyan splash — top right */}
      <svg className="absolute top-[8%] right-[2%] w-48 md:w-72 opacity-[0.12]" viewBox="0 0 200 200" fill="none" data-id="element-132">
        <path d="M140 20c30 15 50 55 40 90s-45 60-80 65-70-10-85-45S20 60 50 35s60-30 90-15z" fill="#00D4FF" data-id="element-133" />
        <circle cx="160" cy="50" r="12" fill="#00D4FF" data-id="element-134" />
        <circle cx="120" cy="15" r="6" fill="#00D4FF" data-id="element-135" />
      </svg>

      {/* Magenta splash — left side */}
      <svg className="absolute top-[22%] left-[-1%] w-40 md:w-64 opacity-[0.10]" viewBox="0 0 200 200" fill="none" data-id="element-136">
        <path d="M30 80c-15-40 20-75 60-70s65 35 75 70-10 70-50 80S45 120 30 80z" fill="#FF1493" data-id="element-137" />
        <circle cx="45" cy="30" r="8" fill="#FF1493" data-id="element-138" />
        <circle cx="130" cy="160" r="10" fill="#FF1493" data-id="element-139" />
        <ellipse cx="20" cy="110" rx="5" ry="12" fill="#FF1493" data-id="element-140" />
      </svg>

      {/* Yellow splash — mid right */}
      <svg className="absolute top-[38%] right-[-2%] w-44 md:w-60 opacity-[0.12]" viewBox="0 0 200 200" fill="none" data-id="element-141">
        <path d="M100 10c45 5 85 40 80 85s-30 75-75 85-90-15-95-60S55 5 100 10z" fill="#FFD700" data-id="element-142" />
        <circle cx="50" cy="40" r="7" fill="#FFD700" data-id="element-143" />
        <circle cx="170" cy="100" r="9" fill="#FFD700" data-id="element-144" />
      </svg>

      {/* Blue splash — lower left */}
      <svg className="absolute top-[55%] left-[1%] w-36 md:w-56 opacity-[0.10]" viewBox="0 0 200 200" fill="none" data-id="element-145">
        <path d="M60 30c40-20 90 0 100 45s-15 80-55 95-85 0-100-40S20 50 60 30z" fill="#3B82F6" data-id="element-146" />
        <circle cx="30" cy="80" r="6" fill="#3B82F6" data-id="element-147" />
        <circle cx="155" cy="50" r="8" fill="#3B82F6" data-id="element-148" />
      </svg>

      {/* Green splash — right lower */}
      <svg className="absolute top-[68%] right-[3%] w-32 md:w-52 opacity-[0.10]" viewBox="0 0 200 200" fill="none" data-id="element-149">
        <path d="M80 20c35-10 80 15 90 55s-20 75-60 85-80-5-95-45S45 30 80 20z" fill="#22C55E" data-id="element-150" />
        <circle cx="40" cy="60" r="7" fill="#22C55E" data-id="element-151" />
        <circle cx="160" cy="130" r="5" fill="#22C55E" data-id="element-152" />
      </svg>

      {/* Magenta splash — bottom left */}
      <svg className="absolute top-[82%] left-[3%] w-36 md:w-48 opacity-[0.08]" viewBox="0 0 200 200" fill="none" data-id="element-153">
        <path d="M90 15c40 0 80 30 85 70s-25 70-65 80-75-10-90-50S50 15 90 15z" fill="#FF1493" data-id="element-154" />
        <circle cx="160" cy="60" r="6" fill="#FF1493" data-id="element-155" />
      </svg>

      {/* Cyan drip — bottom right */}
      <svg className="absolute top-[90%] right-[5%] w-28 md:w-40 opacity-[0.10]" viewBox="0 0 100 160" fill="none" data-id="element-156">
        <path d="M50 10c25 0 40 20 40 50s-15 45-40 55S10 90 10 60 25 10 50 10z" fill="#00D4FF" data-id="element-157" />
        <ellipse cx="50" cy="130" rx="8" ry="20" fill="#00D4FF" data-id="element-158" />
      </svg>

      {/* Small yellow drip — top left accent */}
      <svg className="absolute top-[5%] left-[8%] w-16 md:w-24 opacity-[0.15]" viewBox="0 0 60 100" fill="none" data-id="element-159">
        <ellipse cx="30" cy="30" rx="20" ry="25" fill="#FFD700" data-id="element-160" />
        <ellipse cx="30" cy="75" rx="6" ry="18" fill="#FFD700" data-id="element-161" />
      </svg>

      {/* === T-SHIRT SILHOUETTES — very subtle at 3-5% opacity === */}

      <svg className="absolute top-[15%] right-[5%] w-20 md:w-32 opacity-[0.04] rotate-[-8deg]" viewBox="0 0 120 140" fill="white" data-id="element-162">
        <path d="M35 5L5 35l15 8v87h80V43l15-8L85 5l-15 15H50L35 5z" data-id="element-163" />
        <rect x="40" y="55" width="40" height="5" rx="2" opacity="0.5" data-id="element-164" />
        <rect x="45" y="65" width="30" height="3" rx="1" opacity="0.3" data-id="element-165" />
      </svg>

      <svg className="absolute top-[40%] left-[3%] w-16 md:w-28 opacity-[0.035] rotate-[12deg]" viewBox="0 0 120 140" fill="white" data-id="element-166">
        <path d="M35 5L5 35l15 8v87h80V43l15-8L85 5l-15 15H50L35 5z" data-id="element-167" />
        <circle cx="60" cy="70" r="15" opacity="0.4" data-id="element-168" />
      </svg>

      <svg className="absolute top-[60%] right-[6%] w-14 md:w-24 opacity-[0.03] rotate-[-15deg]" viewBox="0 0 120 140" fill="white" data-id="element-169">
        <path d="M35 5L5 35l15 8v87h80V43l15-8L85 5l-15 15H50L35 5z" data-id="element-170" />
        <path d="M45 60l15 20 15-20" stroke="white" strokeWidth="3" fill="none" opacity="0.4" data-id="element-171" />
      </svg>

      <svg className="absolute top-[78%] left-[6%] w-18 md:w-26 opacity-[0.03] rotate-[6deg]" viewBox="0 0 120 140" fill="white" data-id="element-172">
        <path d="M35 5L5 35l15 8v87h80V43l15-8L85 5l-15 15H50L35 5z" data-id="element-173" />
        <rect x="35" y="55" width="50" height="4" rx="2" opacity="0.4" data-id="element-174" />
        <rect x="40" y="65" width="40" height="3" rx="1" opacity="0.3" data-id="element-175" />
        <rect x="45" y="73" width="30" height="3" rx="1" opacity="0.2" data-id="element-176" />
      </svg>

      <svg className="absolute top-[92%] right-[10%] w-12 md:w-20 opacity-[0.025] rotate-[-5deg]" viewBox="0 0 120 140" fill="white" data-id="element-177">
        <path d="M35 5L5 35l15 8v87h80V43l15-8L85 5l-15 15H50L35 5z" data-id="element-178" />
      </svg>

      {/* === SOFT AMBIENT GLOWS — large blurred circles for depth === */}
      <div className="absolute top-[30%] left-[-5%] w-64 h-64 md:w-96 md:h-96 rounded-full bg-accent-pink/[0.06] blur-[80px]" data-id="element-179" />
      <div className="absolute top-[50%] right-[-5%] w-56 h-56 md:w-80 md:h-80 rounded-full bg-accent-cyan/[0.06] blur-[80px]" data-id="element-180" />
      <div className="absolute top-[70%] left-[10%] w-48 h-48 md:w-72 md:h-72 rounded-full bg-accent-yellow/[0.05] blur-[80px]" data-id="element-181" />
    </div>;
}